
/********
 * HorizontalCard
 */
 const HorizontalCard = function () {
    var _ = this;

    // init
    _.init = () => {

        /*$('.horizontal-post-cards .post-card:not(.workstream-card)').each((index, card) => {
            let contentHeight = $(card).find('.content_block').outerHeight();
            contentHeight = contentHeight < 216 ? 216 : contentHeight;
            $(card).find('.featured_image').css('height', contentHeight + 'px');
        });*/
    }

}

/******************
 * Initialise HorizontalCard
 */
var horizontalCard = new HorizontalCard();

export default horizontalCard;






// WEBPACK FOOTER //
// ./scripts/components/horizontal-card.js